__turbopack_context__.v({
  "addIcon": "NavSearch-module__3JQYXa__addIcon",
  "backdrop": "NavSearch-module__3JQYXa__backdrop",
  "clearButton": "NavSearch-module__3JQYXa__clearButton",
  "desktopComboboxWrapper": "NavSearch-module__3JQYXa__desktopComboboxWrapper",
  "desktopSearch": "NavSearch-module__3JQYXa__desktopSearch",
  "desktopSearchInput": "NavSearch-module__3JQYXa__desktopSearchInput",
  "desktopSearchOpen": "NavSearch-module__3JQYXa__desktopSearchOpen",
  "drawerField": "NavSearch-module__3JQYXa__drawerField",
  "drawerSelectedDestination": "NavSearch-module__3JQYXa__drawerSelectedDestination",
  "drawerSubmitButton": "NavSearch-module__3JQYXa__drawerSubmitButton",
  "itemContent": "NavSearch-module__3JQYXa__itemContent",
  "mobileCloseButton": "NavSearch-module__3JQYXa__mobileCloseButton",
  "mobileDestinationField": "NavSearch-module__3JQYXa__mobileDestinationField",
  "mobileDialog": "NavSearch-module__3JQYXa__mobileDialog",
  "mobileModal": "NavSearch-module__3JQYXa__mobileModal",
  "mobileOverlay": "NavSearch-module__3JQYXa__mobileOverlay",
  "mobileOverlayContent": "NavSearch-module__3JQYXa__mobileOverlayContent",
  "mobileOverlayHeader": "NavSearch-module__3JQYXa__mobileOverlayHeader",
  "mobileSlideIn": "NavSearch-module__3JQYXa__mobileSlideIn",
  "pinAndTextContainer": "NavSearch-module__3JQYXa__pinAndTextContainer",
  "placeName": "NavSearch-module__3JQYXa__placeName",
  "searchContainer": "NavSearch-module__3JQYXa__searchContainer",
  "searchIconButton": "NavSearch-module__3JQYXa__searchIconButton",
});
